import type { BotExecution, BotExecutionDetail } from '../services/api';

/** Rótulo do tipo de disparo (manual vs automático). */
export function getBotDisparoLabel(exec: Pick<BotExecution, 'origem_disparo' | 'tipo_execucao'>): string {
  const origem = exec.origem_disparo;
  if (origem === 'agendado') return 'Automático (agendado 01:01)';
  if (origem === 'backfill') return 'Manual (backfill histórico)';
  if (origem === 'manual') return 'Manual (comando)';
  if (exec.tipo_execucao === 'backfill') return 'Manual (backfill histórico)';
  if (exec.tipo_execucao === 'incremental') return 'Automático (agendado)';
  return 'Manual';
}

export function buildBotExecutionDetail(exec: BotExecutionDetail): string {
  const disparo = getBotDisparoLabel(exec);
  const lines = [
    `Canal: MMA Power BI (BOT)`,
    `Disparo: ${disparo}`,
    `Frequência: diário às 01:01 (apenas execuções agendadas)`,
    `Status: ${exec.status}`,
    `Tipo: ${exec.tipo_execucao}`,
    `Início: ${exec.inicio_execucao}`,
    `Fim: ${exec.fim_execucao ?? '-'}`,
    `Janela: ${exec.data_inicio_busca ?? '-'} → ${exec.data_fim_busca ?? '-'}`,
    `Processados: ${exec.total_processados} | Novos: ${exec.total_novos} | Atualizados: ${exec.total_atualizados} | Ignorados: ${exec.total_ignorados} | Erros: ${exec.total_erros}`,
  ];
  if (exec.mensagem_erro) lines.push(`Erro: ${exec.mensagem_erro}`);
  if (exec.log_execucao) lines.push('', 'Log:', exec.log_execucao);
  return lines.join('\n');
}

export function buildBotExecutionSummary(exec: BotExecution): string {
  const disparo = getBotDisparoLabel(exec);
  const ranToday = (exec.inicio_execucao || '').slice(0, 10) === new Date().toISOString().slice(0, 10);
  return [
    `Disparo: ${disparo}`,
    `Executou hoje: ${ranToday ? 'sim' : 'não'}`,
    `Tipo: ${exec.tipo_execucao}`,
    `Janela: ${exec.data_inicio_busca ?? '-'} → ${exec.data_fim_busca ?? '-'}`,
    `Processados: ${exec.total_processados} | Novos: ${exec.total_novos} | Atualizados: ${exec.total_atualizados} | Ignorados: ${exec.total_ignorados} | Erros: ${exec.total_erros}`,
  ].join(' • ');
}
